document.addEventListener('turbolinks:load', () => {
  var analysisTab = document.querySelector('#financials-analysis-tab')
  if (analysisTab) {
    analysisTab.addEventListener('click', () => {
      var form = document.querySelector('#financials-analysis form')
      if (form) {
        form.querySelector('.preloader-wrapper').classList.remove('hide')
        form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }
    })
  }
})